import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BaseComponent } from "../../../core/components/base.component";
import { JobAssigneePickerController } from "./job-assignee-picker.controller";

@Component({
    selector: "vas-job-assignee-picker",
    template: `
        <ion-select placeholder="Engineer" (ionChange)="onChange($event)" item-content>
            <ion-option *ngFor="let item of items" [value]="item.id" [selected]="defaultUser(item.id)">{{ item.label }}
            </ion-option>
        </ion-select>
        <button
        item-content
        ion-button
        clear
        icon-only
        small
        (click)="onClear()"
        >
        <ion-icon name="close"></ion-icon>
        </button>
    `,
    viewProviders: [
        JobAssigneePickerController
    ]
})
export class JobAssigneePickerComponent extends BaseComponent {

    @Input() assigneeId: string;
    @Output() changed = new EventEmitter<string>();

    protected model: any;

    constructor(protected controller: JobAssigneePickerController) {
        super();
    }

    ngOnInit(): void {
        this.controller.model$
            .takeUntil(this.ngUnsubscribe)
            .subscribe(model => {
                this.model = model;
            });
    }

    get items(): Array<any> {
        return this.model ? this.model.items : [];
    }

    onChange($event): void {
        this.changed.next($event);
    }

    defaultUser(id: string): boolean {
        return id ? id === this.assigneeId : false;
    }

    onClear(): void {
        this.changed.next("");
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/job-assignee-picker/job-assignee-picker.component.ts